import './NewPage.css';
import ImageSlider from './ImageSlider';
import VideoSection from './VideoSection';
import HomeMap2 from './HomeMap2';
import PhotoCarousel from './PhotoCarousel';
import YearlyPhotoCarousel from './YearlyPhotoCarousel2';
import homeSliderImages from '../data/homeSliderImages';
import videoCategories from '../data/videoCategories.json';
import awardsGallerySection from '../data/awardsGallerySection.json';
import loveDayGallerySection from '../data/loveDayGallerySection.json';
import yearlyPhotosData from '../data/photos.json';

const baseImagePath = `${process.env.PUBLIC_URL}/images/`;
const publicUrl = (process.env.PUBLIC_URL || '').replace(/\/$/, '');

function mapGallerySection(section) {
  if (!section || typeof section !== 'object') {
    return null;
  }

  const slides = Array.isArray(section.slides)
    ? section.slides.map((slide) => ({
        ...slide,
        image: `${baseImagePath}${slide.file}`,
        thumbnail: `${baseImagePath}${slide.file}`,
      }))
    : [];

  return {
    ...section,
    slides,
  };
}

const yearlyPhotos = yearlyPhotosData.map((photo) => ({
  ...photo,
  image: `${publicUrl}${photo.url}`,
}));

const awardsCarouselSection = mapGallerySection(awardsGallerySection);
const loveDayCarouselSection = mapGallerySection(loveDayGallerySection);

function NewPage() {
  return (
    <div className="new-page">
      <section className="new-page__slider">
        <ImageSlider images={homeSliderImages} />
      </section>

      <section className="new-page__content">
        <section id="foundation-footprints" className="new-page__home-map">
          <HomeMap2 />
        </section>

        <section id="big-events" className="new-page__timeline">
          <div className="new-page__timeline-header">
            <p className="new-page__timeline-eyebrow">重要里程碑</p>
            <h2>至善大事記</h2>
            <p>
              從 1995 年立案起一路陪伴，透過年表輪播快速瀏覽每一個跨越的足跡與服務成果。
            </p>
          </div>
          <YearlyPhotoCarousel photos={yearlyPhotos} autoplayInterval={6000} />
        </section>

        <VideoSection id="video-section" categories={videoCategories} />

        {/* <article className="new-page__card new-page__placeholder">
          <h2>校園友善風雲錄預留位</h2>
          <p>
            將還原圖文雙欄排版與 `ImageFrame` 元件，保留「短影音競賽」說明內容。
          </p>
        </article>

        <article className="new-page__card new-page__placeholder">
          <h2>2025 友愛日預留位</h2>
          <p>
            重現圖片與文案的左右互換版面，套用 Astro 版的圖像與標題結構。
          </p>
        </article>

        <article className="new-page__card new-page__placeholder">
          <h2>最新消息輪播預留位</h2>
          <p>
            將在此導入 `NewsCarousel`，呈現最新公告與圖片的橫向滑動效果。
          </p>
        </article> */}

        <section className="new-page__gallery">
          {awardsCarouselSection ? (
            <article id={awardsCarouselSection.id} className="new-page__gallery-section">
              <div className="new-page__gallery-header">
                <p className="new-page__gallery-eyebrow">{awardsCarouselSection.eyebrow}</p>
                <h2>{awardsCarouselSection.title}</h2>
                <p>{awardsCarouselSection.description}</p>
              </div>
              <div className="new-page__gallery-carousel">
                <PhotoCarousel
                  slides={awardsCarouselSection.slides}
                  autoPlayInterval={awardsCarouselSection.autoPlayInterval}
                  showMeta={false}
                  showDescription={false}
                />
              </div>
            </article>
          ) : null}

          {loveDayCarouselSection ? (
            <article id={loveDayCarouselSection.id} className="new-page__gallery-section">
              <div className="new-page__gallery-header">
                <p className="new-page__gallery-eyebrow">{loveDayCarouselSection.eyebrow}</p>
                <h2>{loveDayCarouselSection.title}</h2>
                <p>{loveDayCarouselSection.description}</p>
              </div>
              <div className="new-page__gallery-carousel">
                <PhotoCarousel
                  slides={loveDayCarouselSection.slides}
                  autoPlayInterval={loveDayCarouselSection.autoPlayInterval}
                  showMeta={false}
                  showDescription={false}
                />
              </div>
            </article>
          ) : null}
        </section>
      </section>
    </div>
  );
}

export default NewPage;
